<template>

  <b-form-group
    :label="label"
    :label-for="id"
    class="bold-label mb-4 image-input"
    :state="image.state"
    :invalid-feedback="image.invalidFeedback">
    <div v-if="sizeDetails"> {{sizeDetails}} </div>
    <div v-if="formatDetails"> {{formatDetails}} </div>
    <div class="main-red-color bold-text" v-if="otherDetails"> {{otherDetails}} </div>
    <b-form-file
      :id="id"
      v-model="image.value"
      :placeholder="placeholder"
      :state="image.state"
      accept="image/jpeg, image/png, image/gif"
      :required="isRequired">
    </b-form-file>
    <b-form-text>{{helpMessage}}</b-form-text>
    <label :for="id" class="image mt-4 d-flex" v-if="image.value || image.src">
      <img
        :src="fileUrl"
        alt="image">
    </label>
    <label :for="id" class="image-label form-control mt-4" v-else>
        <i class="ph ph-image"></i>
        <span class="image-placeholder" v-if="sizeDetails"> {{sizeDetails}} </span>
        <span class="image-placeholder" v-if="formatDetails"> {{formatDetails}} </span>
    </label>
  </b-form-group>

</template>

<script>
export default {
  name: 'ImageField',

  props: {
    id: {
      type: String,
      default: 'image-input'
    },
    label: {
      type: String,
      default: function () {
        return this.$t('Image')
      }
    },
    placeholder: {
      type: String,
      default: null
    },
    info: {
      type: String,
      default: null
    },
    image: {
      type: Object,
      default: null
    },
    isRequired: {
      type: Boolean,
      default: false
    },
    sizeDetails: {
      type: String,
      default: null
    },
    formatDetails: {
      type: String,
      default: null
    },
    otherDetails: {
      type: String,
      default: null
    },
    helpMessage: {
      type: String,
      default: null
    }
  },

  computed: {

    fileUrl () {
      return this.image.value ? window.URL.createObjectURL(this.image.value): (this.image.src? process.env.SERVER_URL + this.image.src: null)
    }

  },

}
</script>

<style scoped>

.image-label {
  width: 100%;
  height: 200px;
  display: flex;
  flex-direction: column;
}

.ph {
  font-size: 120px;
  color: var(--placeholder-text-color);
  margin: auto;
}

.image-placeholder {
  color: var(--placeholder-text-color);
  margin: auto;
  font-family: "Montserrat-Regular", "Arial", sans-serif;
}

.image {
  width: 100%;
  border: var(--main-grey) 1px solid;
  border-radius: var(--main-border-radius);
  overflow: hidden;
}

img {
  margin-left: auto;
  margin-right: auto;
  object-fit: contain;
  max-width: 100%;
  aspect-ratio: 16/9;
}

</style>



// WEBPACK FOOTER //
// src/components/b122/editFields/ImageField.vue